import {
  createEditorPlatformManifestServicesError,
  EditorPlatformManifestServicesErrorCode,
} from '../errors';
import { DependencyToken, IDependencyAPI } from './dependencies';

export class DependenciesContributor {
  #locked = false;

  #state: Partial<{
    [K in DependencyToken]: Extract<IDependencyAPI, { type: K }>['api'];
  }> = {};

  lock() {
    this.#locked = true;
  }

  set<TToken extends DependencyToken>(
    token: TToken,
    api: Extract<IDependencyAPI, { type: TToken }>['api'],
  ) {
    if (this.#locked) {
      throw createEditorPlatformManifestServicesError(
        EditorPlatformManifestServicesErrorCode.ExternalAPIHandlers,
        `external contributor is locked`,
      );
    }

    (this.#state as any)[token] = api;

    return this;
  }

  getTokens() {
    return this.#state;
  }

  has<TToken extends DependencyToken>(token: TToken) {
    return !!this.#state[token];
  }

  get<TToken extends DependencyToken>(token: TToken) {
    return this.#state[token]! ?? throwWhenUsedAPI(token);
  }
}

function throwWhenUsedAPI(token: DependencyToken): any {
  const notConfiguredException = () => {
    return createEditorPlatformManifestServicesError(
      EditorPlatformManifestServicesErrorCode.ExternalAPIHandlers,
      `"${token}" token is not configured within the platform's external APIs`,
    );
  };

  return new Proxy((() => {}) as any, {
    get() {
      throw notConfiguredException();
    },
    set() {
      throw notConfiguredException();
    },
    apply() {
      throw notConfiguredException();
    },
  });
}
